import { FC } from 'react';

import type { SanityMiniLeagueWin } from '@lib/sanity/types';

type MiniLeagueWinsTickerProps = {
  miniLeagueWins: SanityMiniLeagueWin[];
};

const MiniLeagueWinsTicker: FC<MiniLeagueWinsTickerProps> = ({
  miniLeagueWins
}) => {
  if (!miniLeagueWins || miniLeagueWins.length === 0) return null;

  // Duplicate items to create seamless infinite scroll
  const duplicatedItems = [...miniLeagueWins, ...miniLeagueWins];

  return (
    <div className="overflow-hidden">
      <style>{`
        @keyframes paywall-ticker-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .paywall-mini-league-ticker-track {
          animation: paywall-ticker-scroll 30s linear infinite;
        }

        @media (prefers-reduced-motion: reduce) {
          .paywall-mini-league-ticker-track {
            animation: none;
          }
        }
      `}</style>
      <div className="paywall-mini-league-ticker-track flex w-max whitespace-nowrap">
        {duplicatedItems.map((win, index) => (
          <div
            key={`${win._key}-${index}`}
            className="mx-2 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-neutral-300 bg-white px-3.5 py-1.5 text-xs text-neutral-600 font-body"
          >
            <span className="font-bold text-neutral-800">{win.memberName}</span>
            <span>{win.winClaim}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MiniLeagueWinsTicker;
